// Live (DOM) rendering of a saved cover layout: mini cards for the vault
// grid and big cards for the share page. Rare covers keep their animated
// holographic shimmer + Collector's Frame + corner seal (never flattened).
import { Sparkles, Star } from "lucide-react";
import { BGS, ICONS, hasRare } from "../../lib/coverArt";

export const CoverSeal = ({ small = false }) => (
  <div className={`absolute ${small ? "bottom-1 right-1" : "bottom-2 right-2"} flex flex-col items-center pointer-events-none z-10`} data-testid="cover-seal">
    <div className={`${small ? "w-8 h-8" : "w-12 h-12"} rounded-full bg-gradient-to-br from-amber-200 via-amber-500 to-amber-800 border-2 border-amber-100 flex items-center justify-center shadow-lg`}>
      <Star className={`${small ? "h-4 w-4" : "h-6 w-6"} fill-amber-50 text-amber-50`} aria-hidden="true" />
    </div>
    <span className={`mt-0.5 rounded bg-amber-700 border border-amber-300 px-1 py-0.5 ${small ? "text-[5px]" : "text-[7px]"} font-extrabold uppercase tracking-wider text-amber-50 whitespace-nowrap`}>
      Golden Star Author Edition
    </span>
  </div>
);

export const CoverCard = ({ cover, className = "", small = true }) => {
  const rare = hasRare(cover);
  const inner = (
    <div
      className="relative w-full aspect-[3/4] rounded-2xl overflow-hidden"
      style={{ background: (BGS[cover?.bg] || BGS.honey).css }}
      data-testid="cover-card"
    >
      <p className={`absolute top-[5%] inset-x-2 text-center font-extrabold font-display text-white drop-shadow-[0_2px_3px_rgba(0,0,0,0.6)] ${small ? "text-sm" : "text-2xl"} truncate`}>
        {cover?.title || ""}
      </p>
      {(cover?.stickers || []).map((s, i) => {
        const I = ICONS[s.sid] || Sparkles;
        const base = small ? 0.62 : 1;
        return (
          <span key={i} className="absolute" style={{ left: `${s.x}%`, top: `${s.y}%`, transform: `translate(-50%,-50%) scale(${(s.scale || 1) * base}) rotate(${s.rot || 0}deg)` }}>
            <span className={`flex items-center justify-center w-14 h-14 rounded-xl ${s.rare ? "holo-gleam bg-amber-200/15" : ""}`}>
              <I className={`h-10 w-10 ${s.rare ? "text-amber-300 fill-amber-400/60 drop-shadow-[0_0_8px_rgba(251,191,36,0.9)]" : "text-white fill-white/25 drop-shadow-[0_2px_3px_rgba(0,0,0,0.5)]"}`} aria-hidden="true" />
            </span>
          </span>
        );
      })}
      {rare && <CoverSeal small={small} />}
    </div>
  );
  return rare ? (
    <div className={`foil-border rounded-[18px] p-1 ${className}`} data-testid="cover-collectors-frame">{inner}</div>
  ) : (
    <div className={className}>{inner}</div>
  );
};
